module.exports = __webpack_public_path__ + "img/1f987.6d9eecf.svg";